export default {
    COMPANY_REPORT_SUMBIT: 'company_report_submit',
    COMPANY_REPORT_SEARCH_TYPES: {
        HID: 'hid',
        ORG_NUMBER: 'org_number',
        COMPANY_NAME: 'company_name',
        ORDER_NUMBER: 'order_number',
    },
    SEARCH_STATS_SUMBIT: 'search_stats_submit',
    ALL_PLACES: 'all_places',
};
